export class GetTestShadowConsistencyStatus200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "lastPassed",
            "baseName": "lastPassed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "shadowSnapshotId",
            "baseName": "shadowSnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastCheckTimestamp",
            "baseName": "lastCheckTimestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastPassedTimestamp",
            "baseName": "lastPassedTimestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastCheckCommit",
            "baseName": "lastCheckCommit",
            "type": "string",
            "format": ""
        },
        {
            "name": "diffSummary",
            "baseName": "diffSummary",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTestShadowConsistencyStatus200Response.attributeTypeMap;
    }
    constructor() {
    }
}
